<template>
    <div>
        <div v-if="options_loaded && passed_filter && panel_required">
            <div class="designeroption" :data-designer-component-id="component_id">
                <h3>
                    {{ title }}
                    <span v-if="show_help_text" data-designer-help-text="{{help_text}}"><i class="fa fa-question-circle help-text-icon"></i></span>
                </h3>
                <div class="stylesoption">
                    <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                        <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                    </select>
                    <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                        <option>Loading Options...</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSelectSideGlass from "../DesignerQuestionSelectSideGlass.vue";

    export default {
        mixins: [
            DesignerQuestionSelectSideGlass
        ],
        props:{
            title: {
                default(){
                    return 'Select Side Panel Glass';
                }
            },
            frameCombination: {
                required: true
            },
            sideVariant: {
                required: true
            },
            securedByDesign: {
                required: true,
            },
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/side-glass?frame_combination=' + this.frameCombination + '&secured_by_design=' + this.securedByDesign + '&side_variant=' + this.sideVariant;
            },
            cache_key(){
                return '_' + this.frameCombination + '_' + this.securedByDesign + '_' + this.sideVariant;
            },
            passed_filter(){
                return this.variable_ready(this.frameCombination, this.securedByDesign, this.sideVariant);
            },
        },
        watch: {
          'cache_key': function (val, oldVal) {
            this.update_options();
          },
        }
    }
</script>
